import { render, staticRenderFns } from "./empowerment.vue?vue&type=template&id=b9bbf766&scoped=true"
import script from "./empowerment.vue?vue&type=script&lang=js"
export * from "./empowerment.vue?vue&type=script&lang=js"
import style0 from "./empowerment.vue?vue&type=style&index=0&id=b9bbf766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bbf766",
  null
  
)

export default component.exports